var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFamily(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36920_9595)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3835 27.3941C13.3004 29.2509 12.5515 31.7921 12.388 34.6726H24.9026C24.7391 31.7921 23.9902 29.2509 22.9071 27.3941C21.66 25.2562 20.112 24.2284 18.6453 24.2284C17.1785 24.2284 15.6306 25.2562 14.3835 27.3941ZM26.0947 34.6726C25.7444 28.1476 22.5429 23.038 18.6453 23.038C14.7476 23.038 11.5461 28.1476 11.1958 34.6726C11.1748 35.0645 11.164 35.4616 11.164 35.863L26.1265 35.863C26.1265 35.4616 26.1158 35.0645 26.0947 34.6726Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73914 35.0331L0.356445 35.0331L0.356445 34.438C0.356445 29.5047 1.447 25.009 3.23997 21.7253C5.02072 18.464 7.57848 16.2678 10.548 16.2678C11.7131 16.2678 12.8232 16.6096 13.8454 17.2231L14.5018 17.6171L10.5347 21.5513L7.576 18.4269C6.36005 19.242 5.23587 20.5539 4.28476 22.2958C2.67465 25.2446 1.63622 29.3086 1.55233 33.8428L9.73914 33.8428V35.0331ZM8.66161 17.8421L10.5614 19.8482L12.5404 17.8856C11.8934 17.6036 11.2269 17.4581 10.548 17.4581C9.90933 17.4581 9.27738 17.5887 8.66161 17.8421Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5515 35.0331L37.6467 35.0331V34.438C37.6467 28.5351 36.5467 23.1622 34.7426 19.2426C32.9621 15.3742 30.3821 12.7053 27.3226 12.7053C26.6733 12.7053 25.7513 12.9775 24.9255 13.2993C24.0837 13.6272 23.2271 14.0523 22.6938 14.432L23.3843 15.4017C23.8052 15.102 24.561 14.7188 25.3576 14.4084C26.1704 14.0918 26.913 13.8956 27.3226 13.8956C29.6362 13.8956 31.9206 15.9585 33.6613 19.7403C35.3192 23.3424 36.3812 28.3101 36.4525 33.8428L27.5515 33.8428V35.0331Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6905 20.4751C19.9397 20.4751 20.9523 19.4625 20.9523 18.2134C20.9523 16.9643 19.9397 15.9517 18.6905 15.9517C17.4414 15.9517 16.4288 16.9643 16.4288 18.2134C16.4288 19.4625 17.4414 20.4751 18.6905 20.4751ZM18.6905 21.6655C20.5971 21.6655 22.1427 20.12 22.1427 18.2134C22.1427 16.3068 20.5971 14.7613 18.6905 14.7613C16.784 14.7613 15.2384 16.3068 15.2384 18.2134C15.2384 20.12 16.784 21.6655 18.6905 21.6655Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3805 9.99971C29.0898 9.99971 30.4755 8.61402 30.4755 6.90469C30.4755 5.19537 29.0898 3.80968 27.3805 3.80968C25.6712 3.80968 24.2855 5.19537 24.2855 6.90469C24.2855 8.61402 25.6712 9.99971 27.3805 9.99971ZM27.3805 11.1901C29.7472 11.1901 31.6659 9.27146 31.6659 6.90469C31.6659 4.53793 29.7472 2.61929 27.3805 2.61929C25.0137 2.61929 23.0951 4.53793 23.0951 6.90469C23.0951 9.27146 25.0137 11.1901 27.3805 11.1901Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4769 13.5709C12.0548 13.5709 13.3338 12.2918 13.3338 10.7139C13.3338 9.13609 12.0548 7.857 10.4769 7.857C8.89907 7.857 7.61998 9.13609 7.61998 10.7139C7.61998 12.2918 8.89907 13.5709 10.4769 13.5709ZM10.4769 14.7613C12.7122 14.7613 14.5242 12.9492 14.5242 10.7139C14.5242 8.47866 12.7122 6.66661 10.4769 6.66661C8.24164 6.66661 6.42959 8.47866 6.42959 10.7139C6.42959 12.9492 8.24164 14.7613 10.4769 14.7613Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0233 24.7605V21.9036H28.2137V24.7605H27.0233Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0233 20.4751V17.6182H28.2137V20.4751H27.0233Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0233 16.1897V13.3328H28.2137V16.1897H27.0233Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3835 27.3941C13.3004 29.2509 12.5515 31.7921 12.388 34.6726H24.9026C24.7391 31.7921 23.9902 29.2509 22.9071 27.3941C21.66 25.2562 20.112 24.2284 18.6453 24.2284C17.1785 24.2284 15.6306 25.2562 14.3835 27.3941ZM26.0947 34.6726C25.7444 28.1476 22.5429 23.038 18.6453 23.038C14.7476 23.038 11.5461 28.1476 11.1958 34.6726C11.1748 35.0645 11.164 35.4616 11.164 35.863L26.1265 35.863C26.1265 35.4616 26.1158 35.0645 26.0947 34.6726Z",
    stroke: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73914 35.0331L0.356445 35.0331L0.356445 34.438C0.356445 29.5047 1.447 25.009 3.23997 21.7253C5.02072 18.464 7.57848 16.2678 10.548 16.2678C11.7131 16.2678 12.8232 16.6096 13.8454 17.2231L14.5018 17.6171L10.5347 21.5513L7.576 18.4269C6.36005 19.242 5.23587 20.5539 4.28476 22.2958C2.67465 25.2446 1.63622 29.3086 1.55233 33.8428L9.73914 33.8428V35.0331ZM8.66161 17.8421L10.5614 19.8482L12.5404 17.8856C11.8934 17.6036 11.2269 17.4581 10.548 17.4581C9.90933 17.4581 9.27738 17.5887 8.66161 17.8421Z",
    stroke: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5515 35.0331L37.6467 35.0331V34.438C37.6467 28.5351 36.5467 23.1622 34.7426 19.2426C32.9621 15.3742 30.3821 12.7053 27.3226 12.7053C26.6733 12.7053 25.7513 12.9775 24.9255 13.2993C24.0837 13.6272 23.2271 14.0523 22.6938 14.432L23.3843 15.4017C23.8052 15.102 24.561 14.7188 25.3576 14.4084C26.1704 14.0918 26.913 13.8956 27.3226 13.8956C29.6362 13.8956 31.9206 15.9585 33.6613 19.7403C35.3192 23.3424 36.3812 28.3101 36.4525 33.8428L27.5515 33.8428V35.0331Z",
    stroke: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6905 20.4751C19.9397 20.4751 20.9523 19.4625 20.9523 18.2134C20.9523 16.9643 19.9397 15.9517 18.6905 15.9517C17.4414 15.9517 16.4288 16.9643 16.4288 18.2134C16.4288 19.4625 17.4414 20.4751 18.6905 20.4751ZM18.6905 21.6655C20.5971 21.6655 22.1427 20.12 22.1427 18.2134C22.1427 16.3068 20.5971 14.7613 18.6905 14.7613C16.784 14.7613 15.2384 16.3068 15.2384 18.2134C15.2384 20.12 16.784 21.6655 18.6905 21.6655Z",
    stroke: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3805 9.99971C29.0898 9.99971 30.4755 8.61402 30.4755 6.90469C30.4755 5.19537 29.0898 3.80968 27.3805 3.80968C25.6712 3.80968 24.2855 5.19537 24.2855 6.90469C24.2855 8.61402 25.6712 9.99971 27.3805 9.99971ZM27.3805 11.1901C29.7472 11.1901 31.6659 9.27146 31.6659 6.90469C31.6659 4.53793 29.7472 2.61929 27.3805 2.61929C25.0137 2.61929 23.0951 4.53793 23.0951 6.90469C23.0951 9.27146 25.0137 11.1901 27.3805 11.1901Z",
    stroke: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4769 13.5709C12.0548 13.5709 13.3338 12.2918 13.3338 10.7139C13.3338 9.13609 12.0548 7.857 10.4769 7.857C8.89907 7.857 7.61998 9.13609 7.61998 10.7139C7.61998 12.2918 8.89907 13.5709 10.4769 13.5709ZM10.4769 14.7613C12.7122 14.7613 14.5242 12.9492 14.5242 10.7139C14.5242 8.47866 12.7122 6.66661 10.4769 6.66661C8.24164 6.66661 6.42959 8.47866 6.42959 10.7139C6.42959 12.9492 8.24164 14.7613 10.4769 14.7613Z",
    stroke: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0233 24.7605V21.9036H28.2137V24.7605H27.0233Z",
    stroke: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0233 20.4751V17.6182H28.2137V20.4751H27.0233Z",
    stroke: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0233 16.1897V13.3328H28.2137V16.1897H27.0233Z",
    stroke: "#0C2487"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36920_9595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.990afb9958cc7543c738bf795939627d.svg";
export { ForwardRef as ReactComponent };